import { vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onTouchstartPassive: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.touchstart && _ctx.touchstart(...args))),
    onTouchmovePassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchmove && _ctx.touchmove(...args))),
    onTouchendPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchend && _ctx.touchend(...args)))
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["swipe-progress", { animate: _ctx.animate, wasSwiped: _ctx.wasSwiped }]),
      style: _normalizeStyle({ background: _ctx.gradient })
    }, null, 6), [
      [_vShow, _ctx.show]
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 32))
}